import { useCallback } from "react"
import { useAsync } from "./useAsync"
import {
  geocodeFromPartialAddress,
  regionFromCoords,
} from "../utils/locationUtils"
import { toGeocode } from "./useGeocodeFromPartialAddress"

export async function regionFromAddress(address: string) {
  const newCoordinates = await geocodeFromPartialAddress(address!)
  const geo = toGeocode(newCoordinates)

  return regionFromCoords(geo)
}

export function useRegion(address: string | null | undefined) {
  return useAsync({
    disabled: !address,
    operation: useCallback(async () => regionFromAddress(address!), [address]),
  })
}
